module.exports = __webpack_public_path__ + "img/blog12.2a3eefaa.jpg";